import { Select } from 'antd';
import React from 'react';

import { useLocale } from '@client/store/locale.store';
import {
  applyDocumentDirection,
  i18n,
  setStoredLocale,
} from '@client/utils/i18n.util';
import { ELocales, LOCALE_LABELS } from '@common/types';

/**
 * LangSwitcher component
 * @returns {React.JSX.Element} - The rendered component
 */
export default function LangSwitcher(): React.JSX.Element {
  const { locale, setLocale } = useLocale();

  const handleChange = async (value: string) => {
    const next = value as ELocales;
    setLocale(next);
    setStoredLocale(next);
    applyDocumentDirection(next);
    if (i18n.isInitialized) {
      await i18n.changeLanguage(next);
    }
  };

  return (
    <Select
      style={{ width: 150 }}
      value={locale}
      showSearch
      placeholder="Select a language"
      onChange={handleChange}
      options={Object.values(ELocales).map((code) => ({
        value: code,
        label: LOCALE_LABELS[code],
      }))}
    />
  );
}
